export default __webpack_public_path__ + "static/media/lubaantunGrid5.187ee539.webp";